import { render, staticRenderFns } from "./inserirItemModal.vue?vue&type=template&id=1486dafe&"
import script from "./inserirItemModal.vue?vue&type=script&lang=js&"
export * from "./inserirItemModal.vue?vue&type=script&lang=js&"
import style0 from "./inserirItemModal.vue?vue&type=style&index=0&id=1486dafe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports